/**
 * Bootstrap Loader for script dependancies.
 */

// Load jQuery UI library bundle.
require('jquery-ui/ui/widgets/sortable');

// Load moment.js library.
window.moment = require('moment');

// Load tempusdominus datetime picker library and bootstrap 4 skin.
window.tempusdominus    = require('tempusdominus-core');
window.tempusdominusbs4 = require('tempusdominus-bootstrap-4');

// Load uppy library.
window.uppy = require('@uppy/core');

// Load tus library.
window.tus = require('@uppy/tus');

// Load hls.js player library.
window.hls = require('hls.js');

// Load select2 library.
window.select2 = require('select2/dist/js/select2.full');

// Load Date Range Picker library.
window.daterangepicker = require('daterangepicker');

// Load Highcharts library.
window.Highcharts = require('highcharts');

// Load Highcharts exporting and drilldown modules.
window.HighchartsExporting     = require('highcharts/modules/exporting')(Highcharts);
window.HighchartsDrilldown     = require('highcharts/modules/drilldown')(Highcharts);
window.HighchartsNoDataDisplay = require('highcharts/modules/no-data-to-display')(Highcharts);

// Load datatables library, modules and plugin features.
window.dt                      = require('datatables.net');
window.dtresponsive            = require('datatables.net-responsive');
window.dtresponsivebs4         = require('datatables.net-responsive-bs4');
window.dtbuttons               = require('datatables.net-buttons');
window.dtbuttonsbs4            = require('datatables.net-buttons-bs4');
window.dtbuttonhtml5           = require('datatables.net-buttons/js/buttons.html5');
window.dtbuttonprint           = require('datatables.net-buttons/js/buttons.print.js');
window.dtconditionalPaging     = require('datatables.net-plugins/features/conditionalPaging/dataTables.conditionalPaging.js');
window.dtconditionalPageLength = require('datatables.net-plugins/features/conditionalPageLength/dataTables.conditionalPageLength.js');

// Load specific languages for highlight.js
window.hljs = require("highlight.js/lib/core");
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('sql', require('highlight.js/lib/languages/sql'));
hljs.registerLanguage('xml', require('highlight.js/lib/languages/xml'));

// Load Sanitize Filename lirary.
window.sanitizeFilename = require('sanitize-filename');

// Load the ToastUI Markdown Editor library.
window.MDEditor = require('@toast-ui/editor');

// Load the jsRender module.
window.jsRender = require('jsrender');
